// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"33bfaf5c","621":"0a68535a","654":"25085cda","662":"6536c884","701":"aabda8d5"}[chunkId] + ".chunk.js";
};